// CST207 Step 10: Language switcher component.
// Compact variant (globe icon + dropdown) for sidebar/navbar.
// Uses Radix DropdownMenu for a11y (keyboard nav, focus return).

import { useTranslation } from "react-i18next";
import { Globe } from "lucide-react";
import { SUPPORTED_LNGS } from "@/i18n/config";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

// Language names are proper nouns in their own language — intentionally not translated.
const LANGUAGE_LABELS = {
  de: "Deutsch",
  en: "English",
} satisfies Record<(typeof SUPPORTED_LNGS)[number], string>;

export function LanguageSwitcher() {
  const { i18n, t } = useTranslation("common");

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className="h-8 w-8 shrink-0"
          aria-label={t("languageSwitcher.label")}
        >
          <Globe className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {SUPPORTED_LNGS.map((lng) => (
          <DropdownMenuItem
            key={lng}
            onClick={() => i18n.changeLanguage(lng)}
            className={i18n.language === lng ? "font-semibold" : ""}
            aria-current={i18n.language === lng ? true : undefined}
          >
            {LANGUAGE_LABELS[lng] ?? lng}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
